export class Modal {
  constructor(element) {
    this.element = element;
    this.id = element?.id;
    this.openButtons = document.querySelectorAll(
      `[data-modal-open="${this.id}"]`,
    );
    this.closeButtons = element?.querySelectorAll("[data-modal-close]") || [];
    this.lastFocusedElement = null;

    this.handleKeydown = this.handleKeydown.bind(this);
  }

  getFocusableElements() {
    return this.element.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
    );
  }

  open(trigger = null) {
    if (!this.element) return;

    this.lastFocusedElement = trigger || document.activeElement;

    this.element.hidden = false;
    document.body.style.overflow = "hidden";

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    const focusable = this.getFocusableElements();
    if (focusable.length) {
      focusable[0].focus();
    }

    window.dispatchEvent(
      new CustomEvent("modal:open", {
        detail: {
          id: this.id,
          modal: this.element,
          trigger,
        },
      }),
    );
  }

  close() {
    if (!this.element) return;

    this.element.hidden = true;
    document.body.style.overflow = "";

    this.openButtons.forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });

    window.dispatchEvent(
      new CustomEvent("modal:close", {
        detail: {
          id: this.id,
          modal: this.element,
        },
      }),
    );

    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
    }
  }

  handleKeydown(event) {
    if (this.element.hidden) return;

    if (event.key === "Escape") {
      this.close();
      return;
    }

    if (event.key === "Tab") {
      const focusable = Array.from(this.getFocusableElements());
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  init() {
    if (!this.element) return this;

    this.openButtons.forEach((button) => {
      button.addEventListener("click", () => this.open(button));
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.close());
    });

    document.addEventListener("keydown", this.handleKeydown);

    return this;
  }
}
